import { APIOutput, AppError, Input } from "@amzn/ask-legal-domain";

export interface APIResponse<T> {
    data: APIOutput<T>;
    httpStatusCode: number;
    statusText: string;
}

export const SPOOF_STORAGE_KEY = "pathfinder-spoof-identity";

export function getStoredSpoof(): { id: string } | null {
    const raw = localStorage.getItem(SPOOF_STORAGE_KEY);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (!parsed.id) return null;
        return parsed;
    } catch { return null; }
}

export function toDefaultRequestPayload<T>(body: T) {
    const headers: Record<string, string> = {};
    const spoof = getStoredSpoof();
    if (spoof) {
        headers["x-impersonate-user"] = spoof.id;
    }
    return {
        body: Input.create(body),
        response: true,
        headers
    };
}

export function createApiNotImplementedResponse() {
    return {
        data: APIOutput.createErrorOutput(
            AppError.create(
                "Not Implemented yet",
                404
            )
        ),
        httpStatusCode: 404,
        statusText: "Not Implemented"
    };
}